/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LedgerSourceBreakdownRow } from './LedgerSourceBreakdownRow';
import {
    LedgerSourceBreakdownRowFromJSON,
    LedgerSourceBreakdownRowFromJSONTyped,
    LedgerSourceBreakdownRowToJSON,
    LedgerSourceBreakdownRowToJSONTyped,
} from './LedgerSourceBreakdownRow';

/**
 * 
 * @export
 * @interface GetMyLedgerContributionsResponse
 */
export interface GetMyLedgerContributionsResponse {
    /**
     * 
     * @type {Array<LedgerSourceBreakdownRow>}
     * @memberof GetMyLedgerContributionsResponse
     */
    breakdown: Array<LedgerSourceBreakdownRow>;
    /**
     * 
     * @type {number}
     * @memberof GetMyLedgerContributionsResponse
     */
    totalPoints: number;
    /**
     * 
     * @type {string}
     * @memberof GetMyLedgerContributionsResponse
     */
    periodKey: string;
}

/**
 * Check if a given object implements the GetMyLedgerContributionsResponse interface.
 */
export function instanceOfGetMyLedgerContributionsResponse(value: object): value is GetMyLedgerContributionsResponse {
    if (!('breakdown' in value) || value['breakdown'] === undefined) return false;
    if (!('totalPoints' in value) || value['totalPoints'] === undefined) return false;
    if (!('periodKey' in value) || value['periodKey'] === undefined) return false;
    return true;
}

export function GetMyLedgerContributionsResponseFromJSON(json: any): GetMyLedgerContributionsResponse {
    return GetMyLedgerContributionsResponseFromJSONTyped(json, false);
}

export function GetMyLedgerContributionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMyLedgerContributionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'breakdown': ((json['breakdown'] as Array<any>).map(LedgerSourceBreakdownRowFromJSON)),
        'totalPoints': json['totalPoints'],
        'periodKey': json['periodKey'],
    };
}

export function GetMyLedgerContributionsResponseToJSON(json: any): GetMyLedgerContributionsResponse {
    return GetMyLedgerContributionsResponseToJSONTyped(json, false);
}

export function GetMyLedgerContributionsResponseToJSONTyped(value?: GetMyLedgerContributionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'breakdown': ((value['breakdown'] as Array<any>).map(LedgerSourceBreakdownRowToJSON)),
        'totalPoints': value['totalPoints'],
        'periodKey': value['periodKey'],
    };
}

